import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './sanolivar-style.css';

import Name from './utils/Name.js';

// import components
import Header from './components/Header.jsx';
import Slider from './components/Slider.jsx';
import Form from './components/Form.jsx';
import Footer from './components/Footer.jsx';
import { root, assets } from './utils/Path';
import Chatbot from './components/Chatbot.jsx';

const assetsGestion = './assets/images/gestion/';


createRoot(document.getElementById('gestion')).render(
  <StrictMode>
    <Header active={"Innovación & Servicios"} />
    {/* BANNER */}
    <section className="banner">
      <div className="background">
        <video loading="lazy" autoPlay muted loop src={'./assets/videos/banner-gestion.mp4'}></video>
      </div>
      <div>
        <h1>Servicios Profesionales - Gestión, Soporte y Administración</h1>
        <p className='stretch centered'>Nuestros Servicios Profesionales abarcan un conjunto completo de soluciones diseñadas para cubrir todas las necesidades de su empresa en cuanto a gestión, soporte y administración.</p>
      </div>
    </section>

    <section className="compressed">
      <h2 data-aos="fade-up">Gestión de Proyectos</h2>
      <p data-aos="fade-up" className="stretch">Nuestros expertos en gestión de proyectos se encargan de planificar, ejecutar y supervisar sus iniciativas clave, asegurando que se cumplan los plazos, se controlen los costos y se alcancen los objetivos</p>
      <div className="c2">
        <img loading="lazy" data-aos="fade-right" src={`${assetsGestion}gestion-proyectos.webp`} alt='Persona usando computadora portátil' aria-label='Persona usando computadora portátil' title='Persona usando computadora portátil' />
        <div data-aos="fade-left" className='flex-centered'>
          <h3>Planificación Estratégica</h3>
          <p>Desarrollo de planes de proyecto detallados que se alineen con sus metas de negocio.</p>
          <h3>Coordinación de Equipos</h3>
          <p>Supervisión de todos los recursos y equipos involucrados, garantizando una colaboración eficaz.</p>
          <h3>Monitoreo y Reportes</h3>
          <p>Seguimiento continuo del progreso del proyecto con informes regulares y adaptaciones cuando sea necesario.</p>
        </div>
      </div>
    </section>

    <section className="compressed bg-alt big-gap">
      <h2 data-aos="fade-up">Soporte Técnico</h2>
      <p data-aos="fade-up" className="stretch">Ofrecemos un soporte técnico integral para mantener sus sistemas funcionando sin problemas y resolver cualquier problema rápidamente:</p>
      <div className="exposer" data-aos="fade-right">
        <div className="card-expo flow">
          <img loading="lazy" src={`${assetsGestion}soporte.webp`} alt='Personas estudiando desde un computador portátil' aria-label='Personas estudiando desde un computador portátil' title='Personas estudiando desde un computador portátil' />
          <div className='flex-centered'>
            <h3>Soporte en Tiempo Real</h3>
            <p>Atención a sus necesidades técnicas las 24 horas del día, los 7 días de la semana, con asistencia remota y en sitio.</p>
          </div>
        </div>
        <div className="card-expo flow">
          <img loading="lazy" src={`${assetsGestion}mantenimiento.webp`} alt='Cohete impreso en 3d sobre un escritorio en un estudio.' aria-label='Cohete impreso en 3d sobre un escritorio en un estudio.' title='Cohete impreso en 3d sobre un escritorio en un estudio.' />
          <div className='flex-centered'>
            <h3>Mantenimiento Preventivo</h3>
            <p>Implementación de programas de mantenimiento regular para evitar problemas antes de que ocurran.</p>
          </div>
        </div>
        <div className="card-expo flow">
          <img loading="lazy" src={`${assetsGestion}diagnostico.webp`} alt='Persona preocupada viendo a través de una ventana.' aria-label='Persona preocupada viendo a través de una ventana.' title='Persona preocupada viendo a través de una ventana.' />
          <div className='flex-centered'>
            <h3>Solución de Problemas</h3>
            <p>Diagnóstico y resolución rápida de incidentes técnicos para minimizar el tiempo de inactividad.</p>
          </div>
        </div>
      </div>
    </section>

    <section className="compressed dark">
      <h2 data-aos="fade-up">Administración de Sistemas</h2>
      <p data-aos="fade-up" className="stretch centered">Nos encargamos de la administración de sus sistemas y plataformas tecnológicas para asegurar su eficiencia y seguridad</p>
      <div data-aos="fade-left" className="exposer">
        <div className="card-expo flow">
          <img loading="lazy" src={`${assetsGestion}gestion-ti.webp`} alt='Consola de comandos windows' aria-label='Consola de comandos windows' title='Consola de comandos windows' />
          <div>
            <h3>Gestión de Infraestructura IT</h3>
            <p>Administración completa de servidores, redes y bases de datos para un rendimiento óptimo.</p>
          </div>
        </div>
        <div className="card-expo flow">
          <img loading="lazy" src={`${assetsGestion}cybersecurity.webp`} alt='Información protegida con cadenas y candados.' aria-label='Información protegida con cadenas y candados.' title='Información protegida con cadenas y candados.' />
          <div>
            <h3>Seguridad de la Información</h3>
            <p>Implementación de medidas de seguridad avanzadas para proteger sus datos y sistemas.</p>
          </div>
        </div>
        <div className="card-expo flow">
          <img loading="lazy" src={`${assetsGestion}development.webp`} alt='Pantalla de computadora de alguien programando.' aria-label='Pantalla de computadora de alguien programando.' title='Pantalla de computadora de alguien programando.' />
          <div>
            <h3>Optimización de Procesos</h3>
            <p>Revisión y mejora continua de procesos administrativos para maximizar la productividad.</p>
          </div>
        </div>
      </div>
    </section>

    <section className="compressed">
      <h2 data-aos="fade-up">Áreas de Aplicación</h2>
      <p data-aos="fade-up" className="stretch">Nuestros Servicios Profesionales son ideales para empresas que buscan mejorar la eficiencia operativa y asegurar la continuidad en diversas áreas, tales como:</p>
      <div className="c2">
        <div data-aos="fade-right">
          <img loading="lazy" src={`${assetsGestion}ti.webp`} alt='Computadora portátil' aria-label='Computadora portátil' title='Computadora portátil' />
          <h3>Tecnología de la Información</h3>
          <p className='stretch centered'>Gestión y soporte de sistemas IT complejos para asegurar un funcionamiento continuo y seguro.</p>
        </div>
        <div data-aos="fade-left">
          <img loading="lazy" src={`${assetsGestion}manufactura.webp`} alt='Panorámica de una ciudad industrial' aria-label='Panorámica de una ciudad industrial' title='Panorámica de una ciudad industrial' />
          <h3>Manufactura</h3>
          <p className='stretch centered'>Administración y optimización de procesos productivos para reducir costos y aumentar la calidad.</p>
        </div>
        <div data-aos="fade-right">
          <img loading="lazy" src={`${assetsGestion}health.webp`} alt='Personal de salud viendo a través de un microscopio' aria-label='Personal de salud viendo a través de un microscopio' title='Personal de salud viendo a través de un microscopio' />
          <h3>Salud</h3>
          <p className='stretch centered'>Soporte técnico y administrativo para sistemas médicos y hospitalarios, garantizando un servicio confiable y seguro.</p>
        </div>
        <div data-aos="fade-left">
          <img loading="lazy" src={`${assetsGestion}public.webp`} alt='Panorámica nocturna de una ciudad moderna' aria-label='Panorámica nocturna de una ciudad moderna' title='Panorámica nocturna de una ciudad moderna' />
          <h3>Sector Público</h3>
          <p className='stretch centered'>Soluciones de gestión y soporte para mantener la eficiencia en la administración pública y los servicios al ciudadano.</p>
        </div>
      </div>
    </section>

    {/* <section className='fw bg-alt'>
      <h2 data-aos="fade-up">Opiniones de nuestros Clientes</h2>
      <Slider content={
        <div data-aos="fade-up">
          <div className='witness stars5'>
            <p>Gracias a la solución de HPE, hemos optimizado nuestros procesos de IA y mejorado la eficiencia operativa en poco tiempo.</p>
            <div>
              <img loading="lazy" src="./assets/images/placeholder.webp" alt="foto perfil cliente" aria-label="foto perfil cliente" title="foto perfil cliente" />
              <span>Ana López</span>
              <p>Barcelona</p>
            </div>
          </div>
          <div className='witness stars4'>
            <p>La nube privada de HPE ha acelerado nuestra implementación de IA de manera impresionante.</p>
            <div>
              <img loading="lazy" src="./assets/images/placeholder.webp" alt="foto perfil cliente" aria-label="foto perfil cliente" title="foto perfil cliente" />
              <span>Carlos Ruiz</span>
              <p>Madrid</p>
            </div>
          </div>
          <div className='witness stars4'>
            <p>La nube privada de HPE ha acelerado nuestra implementación de IA de manera impresionante.</p>
            <div>
              <img loading="lazy" src="./assets/images/placeholder.webp" alt="foto perfil cliente" aria-label="foto perfil cliente" title="foto perfil cliente" />
              <span>Carlos Ruiz</span>
              <p>Madrid</p>
            </div>
          </div>
        </div>
      } customClass={'compressed'} />
    </section> */}
    <Form
      title={'Conéctese con Nosotros'}
      content={`Confíe en ${Name} para proporcionar la experiencia y el soporte que su empresa necesita para prosperar. Contáctenos hoy mismo para descubrir cómo nuestros Servicios Profesionales pueden ayudarle a gestionar, soportar y administrar sus operaciones de manera más eficiente y segura.`}
      img={{ src: `${assetsGestion}contacto.webp`, alt: 'Señalización que indica continuar avanzando' }}
      form={[
        {
          label: 'Nombre contacto',
          type: 'text',
          id: 'nombre',
          placeholder: 'Ingrese su nombre aquí'
        },
        {
          label: 'Correo electrónico',
          type: 'email',
          id: 'email',
          placeholder: 'Ingrese su correo aquí'
        },
        {
          label: 'Mensaje',
          type: 'textarea',
          id: 'mensaje',
          placeholder: 'Déjanos un mensaje aquí'
        },
        {
          label: 'Enviar Mensaje',
          type: 'submit',
          id: 'submit',
        }
      ]}
      redirect={`${root}servicios-gestion.html`}
    />
    <Footer />
    <Chatbot />
  </StrictMode>
)
